import { UPDATE_AMP_STATUS } from "../../actionTypes/actionsTypes";
import defaultAsyncReducer from "../../defaultReducer";
import { AppAction, BaseAsyncReducerState } from "../../types"

export interface UpdateAmpStatusState extends BaseAsyncReducerState {
    updated: boolean
}

const initialState: UpdateAmpStatusState = {
    updated: false,
    loading: false,
    error: false
}

export function updateAmpStatusReducer(state = initialState, action: AppAction) {
    return defaultAsyncReducer(state, action, UPDATE_AMP_STATUS)
}